var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "floor-plan-icons" },
    _vm._l(_vm.floorPlan.ico, function(icon, index) {
      return _c(
        "a",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: icon.url,
              expression: "icon.url"
            }
          ],
          key: index,
          staticClass: "img-floor-plan-gallery-image",
          on: {
            click: function($event) {
              return _vm.openImage(icon)
            }
          }
        },
        [
          _c("img", {
            staticClass: "floor-plan-icon",
            style: {
              width: icon.width + "px",
              height: icon.height + "px",
              left: icon.x + "px",
              top: icon.y + "px"
            },
            attrs: { src: "/img/icons/cam/cam_" + icon.orientation + ".svg" }
          })
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }